import React from 'react';

import { P } from '../P/P';

import { Section } from './Section';
import { H2 } from './H2';
import { UL } from './UL';
import { OL } from './OL';
import { LI } from './LI';

export const LE1 = () => (
  <Section>

    <P gapAfter>
      Zum Einstieg in das Thema beschäftigen sich die SuS mit ihren eigenen Einstellungen zum Thema Mode und reflektieren diese.
    </P>
    <P>
      Kleidung hat schon lange nicht nur einen praktischen Nutzen, sondern als Mode auch einen Symbolwert. Mit ausgesuchter Kleidung kann man darstellen, wer man ist und was einen ausmacht. Mode trägt zum Image bei. Marken z. B. rücken immer weiter in den Vordergrund – vom kleinen Hinweisschild am Rücken haben es die Labels inzwischen mitten auf die Brust des Shirts geschafft. Gerade Jugendliche in der Orientierungsphase finden hierin Identifikation und Gruppenzugehörigkeit. Aber eben auch Ausgrenzung: Wer es sich nicht leisten kann mitzuhalten, zieht sich zurück oder geht auf Gegenwehr.
    </P>
    <P>
      Das ist kein neues Phänomen, aber der Trend verstärkte sich in den 2000ern.
    </P>

    <H2>Unterrichtsimpulse:</H2>

    <UL>
      <LI>
        <P><b>Meinungsbilder</b> abfragen:</P>
        <P>
          Stellen Sie verschiedene Aussagen vor. Die SuS positionieren sich im Klassenraum dazu, ob sie voll zustimmen, teils zustimmen oder gar nicht zustimmen. Halten Sie das Ergebnis in einer Statistik an der Tafel/am Whiteboard fest:
        </P>
        <OL>
          <LI>Ich trage gerne Markenklamotten.</LI>
          <LI>Es ist mir wichtig, Modetrends nicht zu verpassen.</LI>
          <LI>Ich möchte mich von der Masse absetzen.</LI>
          <LI>Leute, die sich keine neuen Sachen leisten können, tun mir leid.</LI>
          <LI>Meine Freunde haben einen ähnlichen Style wie ich.</LI>
          <LI>Secondhand kommt für mich nicht in Frage.</LI>
        </OL>
      </LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE1.js